import React from "react";

const HeartIcon = ({ className, ...rest }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 24 24"
      className={className ? className : "w-[24px] h-[24px]"}
      {...rest}
    >
      <g clipPath="url(#clip0_7789_121801)">
        <path
          fill="currentColor"
          d="M22.064 3.97a6.7 6.7 0 0 0-9.466 0l-.606.605-.606-.606a6.7 6.7 0 0 0-9.465 0c-2.557 2.557-2.573 6.609-.039 9.427 2.312 2.568 9.13 8.118 9.42 8.353.196.16.432.238.667.238h.023c.243.01.487-.073.69-.238.29-.235 7.108-5.785 9.42-8.354 2.535-2.817 2.518-6.87-.038-9.426m-1.537 8.008c-1.802 2.002-6.757 6.132-8.535 7.597-1.78-1.465-6.732-5.594-8.535-7.597-1.768-1.965-1.784-4.764-.038-6.51A4.56 4.56 0 0 1 6.653 4.13a4.56 4.56 0 0 1 3.235 1.338L11.22 6.8c.159.159.358.253.568.287.34.073.71-.022.975-.287l1.333-1.332a4.58 4.58 0 0 1 6.469 0c1.746 1.746 1.73 4.545-.038 6.51"
        ></path>
        <g clipPath="url(#clip1_7789_121801)">
          <g clipPath="url(#clip2_7789_121801)">
            <path d="M12 21.513a.64.64 0 0 1-.322-.086 38.5 38.5 0 0 1-5.29-3.807c-1.547-1.334-2.782-2.657-3.67-3.932C1.568 12.038.991 10.45 1 8.97c.011-1.722.628-3.342 1.738-4.562 1.128-1.24 2.634-1.922 4.24-1.922 2.057 0 3.94 1.153 5.022 2.98 1.083-1.827 2.965-2.98 5.023-2.98 1.517 0 2.964.616 4.076 1.735 1.22 1.227 1.912 2.961 1.9 4.757-.008 1.478-.597 3.063-1.75 4.711-.89 1.275-2.123 2.597-3.663 3.93a38.6 38.6 0 0 1-5.262 3.807.64.64 0 0 1-.324.087"></path>
          </g>
          <path d="M22.064 3.97a6.7 6.7 0 0 0-9.466 0l-.606.605-.606-.606a6.7 6.7 0 0 0-9.465 0c-2.557 2.557-2.573 6.609-.039 9.427 2.312 2.568 9.13 8.118 9.42 8.353.196.16.432.238.667.238h.023c.243.01.487-.073.69-.238.29-.235 7.108-5.785 9.42-8.354 2.535-2.817 2.518-6.87-.038-9.426m-1.537 8.008c-1.802 2.002-6.757 6.132-8.535 7.597-1.78-1.465-6.732-5.594-8.535-7.597-1.768-1.965-1.784-4.764-.038-6.51A4.56 4.56 0 0 1 6.653 4.13a4.56 4.56 0 0 1 3.235 1.338L11.22 6.8c.159.159.358.253.568.287.34.073.71-.022.975-.287l1.333-1.332a4.58 4.58 0 0 1 6.469 0c1.746 1.746 1.73 4.545-.038 6.51"></path>
        </g>
      </g>
    </svg>
  );
};

export default HeartIcon;
